module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "content_wrapper",
    staticClass: "crew_right"
  }, [_c('div', {
    staticClass: "conInner"
  }, [_c('div', {
    staticClass: "orderInfo"
  }, [_c('div', {
    staticClass: "order_detail_wrapper",
    staticStyle: {
      "width": "1000px",
      "overflow": "auto"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h1', [_vm._v("订单号："), _c('span', [_vm._v(_vm._s(_vm.info.sn))])]), _vm._v(" "), _c('h2', [_vm._v("订单状态:"), _c('span', [_vm._v(_vm._s(_vm.info.statusText))])]), _vm._v(" "), _c('div', {
    staticClass: "order_invoice"
  })]), _vm._v(" "), _c('div', {
    staticClass: "receiver"
  }, [_c('table', {
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("收货人信息")]), _vm._v(" "), _c('td', [_c('div', [_c('label', [_vm._v("收货地址:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.info.shipping_area))])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("收货人:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.info.ship_name))])]), _vm._v(" "), (_vm.info.ship_mobile !== '') ? _c('div', [_c('label', [_vm._v("手机:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.info.ship_mobile))])]) : _vm._e(), _vm._v(" "), (_vm.info.ship_tel !== '') ? _c('div', [_c('label', [_vm._v("联系电话:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.info.ship_tel))])]) : _vm._e(), _vm._v(" "), _c('div', [_c('label', [_vm._v("邮编:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.info.ship_zip))])])])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("配送方式:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.shipping_type))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("付款方式:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.payment_name))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("订单附言:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.remark))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("送货时间:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.ship_day) + " " + _vm._s(_vm.info.ship_time))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("发票抬头:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.receipt.title))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("发票内容:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.receipt.content))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "goodslist"
  }, [_c('h1', [_vm._v("商品清单")]), _vm._v(" "), _c('table', {
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0",
      "width": "100%"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.info.items), function(item) {
    return _c('tr', [_c('td', [_vm._v("\n                  " + _vm._s(item.sn) + "\n                ")]), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "link blue",
      attrs: {
        "to": {
          path: '/goods',
          query: {
            goods_id: item.goods_id
          }
        },
        "target": "_blank"
      }
    }, [_vm._v("\n                    " + _vm._s(item.name) + "\n                  ")])], 1), _vm._v(" "), _c('td', [_vm._v("￥" + _vm._s(item.price.toFixed(2)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.num))]), _vm._v(" "), _c('td', [_vm._v("￥" + _vm._s((item.num * item.price).toFixed(2)))])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "total"
  }, [_c('table', {
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0",
      "border": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("商品总金额:")]), _vm._v(" "), _c('td', [_vm._v("￥" + _vm._s(_vm.info.order_amount.toFixed(2)))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("配送费用:")]), _vm._v(" "), _c('td', [_vm._v("￥" + _vm._s(_vm.info.shipping_amount.toFixed(2)))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("优惠金额:")]), _vm._v(" "), _c('td', {
    staticClass: "discount_green"
  }, [_vm._v("￥" + _vm._s(_vm.info.discount ? _vm.info.discount.toFixed(2) : 0))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("订单总金额:")]), _vm._v(" "), _c('td', [_vm._v("￥" + _vm._s(_vm.info.order_amount.toFixed(2)))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("已付金额:")]), _vm._v(" "), _c('td', {
    staticClass: "already_money"
  }, [_vm._v("￥" + _vm._s(_vm.info.paymoney.toFixed(2)))])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "30px",
      "clear": "both"
    }
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("商品编号")]), _vm._v(" "), _c('th', [_vm._v("商品名称")]), _vm._v(" "), _c('th', [_vm._v("价格")]), _vm._v(" "), _c('th', [_vm._v("数量")]), _vm._v(" "), _c('th', [_vm._v("小计")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f305ce3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/member-center/right/orderdetailForPayment.vue
// module id = 1527
// module chunks = 1